import { sessionDeadline } from "@/session/timeout";

export const SESSION_DEADLINE_KEY = "wisterias.sessionDeadline";
export const SESSION_DEADLINE_EVENT = "wisterias:session-deadline";

export function saveSessionDeadline(expiresIn?: string): void {
  if (typeof window === "undefined" || !expiresIn) return;
  try {
    window.localStorage.setItem(
      SESSION_DEADLINE_KEY,
      String(sessionDeadline(expiresIn))
    );
    window.dispatchEvent(new Event(SESSION_DEADLINE_EVENT));
  } catch {
    // Session expiry remains enforced by the server if browser storage fails.
  }
}

export function clearSessionDeadline(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(SESSION_DEADLINE_KEY);
}

export function readSessionDeadline(): number | null {
  if (typeof window === "undefined") return null;
  const value = Number(window.localStorage.getItem(SESSION_DEADLINE_KEY));
  return Number.isFinite(value) && value > Date.now() ? value : null;
}
